import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateService, TranslateModule} from '@ngx-translate/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../../models/diagram-version.constant';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgIf} from '@angular/common';
import {VersionsListComponent} from '../versions-tree/versions-list.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-version-does-not-exist-popup',
  templateUrl: './version-does-not-exist-popup.component.html',
  styleUrls: ['./version-does-not-exist-popup.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    VersionsListComponent,
    NgIf,
    MatTooltipModule,
    TranslateModule
  ]
})
export class VersionDoesNotExistPopupComponent implements OnInit {
  public draftOnTopVersions;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VersionDoesNotExistPopupComponent>,
    private translateSvc: TranslateService
  ) {}

  versions = this.data.versions;
  diagramId = this.data.diagramId;

  ngOnInit() {
    this.draftOnTopVersions = this.putDraftOnTop(this.versions);
  }

  get message() {
    return this.translateSvc.instant('POPUPS.NAVIGATE_TO_OTHER_VERSION', {
      state: this.transformState(this.data.state)
    });
  }

  transformState(state) {
    if (typeof state === 'object') {
      return '"'.concat(state.name, ' ', state.number.major, '.', state.number.minor, '"');
    }

    switch (state) {
      case DIAGRAM_VERSION_STATES_ENUM.DRAFT:
        return '"'.concat(this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_DRAFT'), '"');

      case DIAGRAM_VERSION_STATES_ENUM.READY:
        return '"'.concat(this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_READY'), '"');

      case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        return '"'.concat(
          this.translateSvc.instant('VERSIONING.BEING_AUTHORISED_DIAGRAM_LABEL'),
          '"'
        );

      case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
        return '"'.concat(this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_ARCHIVE'), '"');

      case DIAGRAM_VERSION_STATES_ENUM.MASTER:
        return '"'.concat(this.translateSvc.instant('VERSIONING.STATE_PUBLISHED'), '"');

      default:
        return '"Unknown"';
    }
  }

  putDraftOnTop(versions) {
    const draftVersion = versions.find(
      version => version.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT
    );

    if (!draftVersion) {
      return versions;
    }

    versions.splice(versions.indexOf(draftVersion), 1);
    versions.unshift(draftVersion);

    return versions;
  }

  navigated() {
    this.dialogRef.close(true);
  }
}
